var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", { attrs: { d: "M13,3V9H21V3", fill: _vm.color } }),
      _c("path", { attrs: { d: "M13,21H21V11H13", fill: _vm.color } }),
      _c("path", { attrs: { d: "M3,21H11V15H3", fill: _vm.color } }),
      _c("path", { attrs: { d: "M3,13H11V3H3V13Z", fill: _vm.color } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }